import { Control } from "../../business-objects/control/control.model";
import { ContactControlConfig } from "./contact-control-config.model";

export class ControlContact extends Control {
    config: ContactControlConfig;
}



// WEBPACK FOOTER //
// ./src/vas/controls/contact/contact-control.model.ts